import AbdelrahmanPortfolio from './AbdelrahmanPortfolio';

function App() {
  return <AbdelrahmanPortfolio />;
}

export default App;
